import { defineStore } from 'pinia'
import { store } from '../index'
import { useCache } from '@/hooks/web/useCache'
import { useAppStoreWithOut } from '@/store/modules/app'
const { wsCache } = useCache()
const appStore = useAppStoreWithOut()

interface PermissionList {
  permissionList: {
    //获客线索导入记录
    accurateCustomerAcquisition_allocationRecords: number[]
    //获客线索分配记录
    accurateCustomerAcquisition_transferRecords: number[]
    //获客线索导入
    accurateCustomerAcquisition_import: number[]
    //获客线索导出
    accurateCustomerAcquisition_derive: number[]
    //获客线索分配
    accurateCustomerAcquisition_allocation: number[]
    //客户管理导入记录
    customerManagement_importRecords: number[]
    //客户管理转移记录
    customerManagement_transferRecords: number[]
    //客户管理导入
    customerManagement_import: number[]
    //客户管理导入
    customerManagement_derive: number[]
    //客户管理转移
    customerManagement_transfer: number[]
    //客户公海分配记录
    openSeaPool_allocationRecords: number[]
    //客户公海导出
    openSeaPool_derive: number[]
    //目标管理新增
    targetsManagement_add: number[]
    //目标管理数据
    targetsManagement_data: number[]
    //目标管理编辑
    targetsManagement_edit: number[]
    //目标管理删除
    targetsManagement_del: number[]
    //合同订单新增
    orderContract_add: number[]
    //合同订单导出
    orderContract_derive: number[]
    //合同订单收款
    orderContract_collection: number[]
    //合同订单退款
    orderContract_refund: number[]
    //合同订单改单
    orderContract_amendment: number[]
    //合同订单编辑
    orderContract_edit: number[]
    //合同订单删除
    orderContract_del: number[]
    //分单记录导出
    splitRecords_derive: number[]
  }
}
export const usePermissionListStore = defineStore('permissionList', {
  state: (): PermissionList => {
    return {
      permissionList: {
        /**
         * 管理员组（老板）：Id:4
         * 导购员：Id:5
         * 店长：Id:6
         * 经理：Id:7
         * 品牌经理：Id:8
         */
        //获客线索导入记录
        accurateCustomerAcquisition_allocationRecords: [4, 5, 6, 7, 8],
        //获客线索分配记录
        accurateCustomerAcquisition_transferRecords: [4, 5, 6, 7, 8],
        //获客线索导入
        accurateCustomerAcquisition_import: [4, 5, 6, 7, 8],
        //获客线索导出
        accurateCustomerAcquisition_derive: [4, 5, 6, 7, 8],
        //获客线索分配
        accurateCustomerAcquisition_allocation: [4, 5, 6, 7, 8],
        //客户管理导入记录
        customerManagement_importRecords: [4, 5, 6, 7, 8],
        //客户管理转移记录
        customerManagement_transferRecords: [4, 5, 6, 7, 8],
        //客户管理导入
        customerManagement_import: [4, 5, 6, 7, 8],
        //客户管理导出
        customerManagement_derive: [4, 5, 6, 7, 8],
        //客户管理转移
        customerManagement_transfer: [4, 5, 6, 7, 8],
        //客户公海分配记录
        openSeaPool_allocationRecords: [4, 5, 6, 7, 8],
        //客户公海导出
        openSeaPool_derive: [4, 5, 6, 7, 8],
        //目标管理新增
        targetsManagement_add: [4, 5, 6, 7, 8],
        //目标管理数据
        targetsManagement_data: [4, 5, 6, 7, 8],
        //目标管理编辑
        targetsManagement_edit: [4, 5, 6, 7, 8],
        //目标管理删除
        targetsManagement_del: [4, 5, 6, 7, 8],
        //合同订单新增
        orderContract_add: [4, 5, 6, 7, 8],
        //合同订单导出
        orderContract_derive: [4, 5, 6, 7, 8],
        //合同订单收款
        orderContract_collection: [4, 5, 6, 7, 8],
        //合同订单退款
        orderContract_refund: [4, 5, 6, 7, 8],
        //合同订单改单
        orderContract_amendment: [4, 5, 6, 7, 8],
        //合同订单编辑
        orderContract_edit: [4, 5, 6, 7, 8],
        //合同订单删除
        orderContract_del: [4, 5, 6, 7, 8],
        //分单记录导出
        splitRecords_derive: [4, 5, 6, 7, 8]
      }
    }
  },
  getters: {},
  actions: {
    filterPermissionList(): string[] {
      const userInfo = wsCache.get(appStore.getUserInfo)
      const permission_list: string[] = []
      for (const key in this.permissionList) {
        if (this.permissionList[key].includes(Number(userInfo.groupname))) {
          permission_list.push(key.toString())
        }
      }
      return permission_list
    }
  }
})

export const usePermissionListStoreWithOut = () => {
  return usePermissionListStore(store)
}
